import {
  buttonThemeUuid,
  editable,
  fields,
  layoutOption,
  outlineColor,
  submitButtonText,
  subscriptionFormStyle,
  tacTextAndIconColor,
  tacs,
  text,
} from '@/src/tools/contentModulesFieldName';
import {
  EPreviewSize,
  SubscriptionLayoutOption,
} from '@/src/types/common/SalesChannel';
import { EnumModuleType } from '@/src/types/common/module';
import {
  CUSOMER_FIELDS,
  SUBSCRIPTION,
  TERMS,
  animationFields,
  moduleStyleFields,
} from 'src/strategies/render/constant';
import i18n from '../i18n';
import { ResponsiveContainer, ResponsiveField } from '../util';
import { ANIMATION, MOUDLE_STYLE, SUBSCRIPTION_STYLE } from './constant';
import {
  animation_not_editable,
  getAnimationTemplate,
  getModuleStyleTemplate,
  moduleStyle_not_editable,
} from './imageCarousel';
const getSubscriptionSettingTemplate = (
  values: any,
  responsiveType: EPreviewSize,
  getI18n,
) => {
  const v =
    responsiveType === EPreviewSize.WIDE ||
    values[`${SUBSCRIPTION}_${editable}`];
  const commonFields = [
    {
      title: getI18n('general.layoutOption'),
      field: ResponsiveField.LayoutOption,
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
      options: [
        {
          label: getI18n('general.centredFormInOneColumn'),
          value: SubscriptionLayoutOption.ONE_COLUMN,
        },
        {
          label: getI18n('general.centredFormInTwoColumns'),
          value: SubscriptionLayoutOption.TWO_COLUMN,
        },
        {
          label: getI18n('general.textOnTheLeftFormOnTheRight'),
          value: SubscriptionLayoutOption.LEFT_TEXT_RIGHT_FORM,
        },
      ],
    },
    {
      title: getI18n('general.responsiveText'),
      disabled: !v,
      field: ResponsiveField.RichText,
    },
    {
      title: getI18n('general.submitButtonTheme'),
      field: ResponsiveField.SubmitButtonTheme,
      disabled: !v,
    },
    {
      title: getI18n('general.submitButtonText'),
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
      field: ResponsiveField.SubmitButtonText,
    },
  ];
  return commonFields;
};

export default (values: any, responsiveType: EPreviewSize, getI18n) => {
  const subscriptionSetting = getSubscriptionSettingTemplate(
    values,
    responsiveType,
    getI18n,
  );
  const moduleStyleSetting = getModuleStyleTemplate(
    values,
    responsiveType,
    EnumModuleType.ResponsiveSubscription,
  );
  const animation = getAnimationTemplate(values, responsiveType);

  // const v = responsiveType === EPreviewSize.WIDE;
  return [
    {
      title: getI18n('general.subscription'),
      id: SUBSCRIPTION,
      onTextCopyEventPath: text,
      field: subscriptionSetting,
      fields: [[layoutOption], [text], [buttonThemeUuid], [submitButtonText]],
    },
    {
      title: i18n['general.content.moduleStyle'],
      id: MOUDLE_STYLE,
      type: ResponsiveContainer.ModuleStyle,
      field: moduleStyleSetting,
      fields: moduleStyleFields,
    },
    {
      title: getI18n('general.subscriptionFormStyle'),
      id: SUBSCRIPTION_STYLE,
      field: [
        {
          field: ResponsiveField.SubscriptionFormStyle,
          disabled:
            responsiveType !== EPreviewSize.WIDE ||
            !(
              responsiveType === EPreviewSize.WIDE ||
              values[`${SUBSCRIPTION_STYLE}_${editable}`]
            ),
        },
      ],
      fields: [
        [subscriptionFormStyle, outlineColor],
        [subscriptionFormStyle, tacTextAndIconColor],
      ],
    },
    {
      title: i18n['general.content.animation'],
      id: ANIMATION,
      field: animation,
      fields: animationFields,
    },
    {
      id: CUSOMER_FIELDS,
      title: getI18n('general.customerInformationFields'),
      field: [
        {
          field: ResponsiveField.CustomerInfomationFields,
          disabled:
            responsiveType !== EPreviewSize.WIDE ||
            !(
              responsiveType === EPreviewSize.WIDE ||
              values[`${CUSOMER_FIELDS}_${editable}`]
            ),
        },
      ],
      fields: [[fields]],
    },
    {
      id: TERMS,
      title: getI18n('general.termsConditions'),
      field: [
        {
          field: ResponsiveField.Terms,
          disabled:
            responsiveType !== EPreviewSize.WIDE ||
            !(
              responsiveType === EPreviewSize.WIDE ||
              values[`${TERMS}_${editable}`]
            ),
        },
      ],
      fields: [[tacs]],
    },
  ];
};

export const not_editable = [
  layoutOption,
  submitButtonText,
  ...moduleStyle_not_editable,
  [subscriptionFormStyle, outlineColor],
  [subscriptionFormStyle, tacTextAndIconColor],
  ...animation_not_editable,
  [fields],
  [tacs],
];
